(function () {
  'use strict';

  /* ── Announcement bar height CSS variable ──────────────────────────────────
   * Sets --mn-announcement-height on :root so navigation CSS can offset:
   *   - .menu-drawer__navigation-container padding-top (drawer aligns with nav)
   *   - .mn-mobile-search top (search overlays sticky-header, not announcement)
   * Updated whenever the bar's box changes and when it is removed.
   *
   * Only written when the value changes: a write on :root restyles every
   * element on the page. It used to re-measure on every body class change,
   * which forced that restyle synchronously inside each menu tap and each
   * header hide/reveal on scroll.
   * ─────────────────────────────────────────────────────────────────────── */
  var lastAnnouncementHeight = null;
  function setAnnouncementHeight() {
    /* The open menu drawer hides the header section, bar included
       (mn-navigation.css), so the bar reads 0 until it closes. Everything
       that reads the variable is hidden behind the drawer meanwhile, so keep
       the last value rather than restyling the page on open and again on
       close. */
    if (document.querySelector('.mobile-menu-drawer[open]')) return;
    var bar = document.getElementById('Announcement-header');
    var h = (bar && bar.offsetHeight > 0) ? bar.offsetHeight : 0;
    if (h === lastAnnouncementHeight) return;
    lastAnnouncementHeight = h;
    document.documentElement.style.setProperty('--mn-announcement-height', h + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setAnnouncementHeight);
  } else {
    setAnnouncementHeight();
  }

  /* A ResizeObserver reports after layout, so reading offsetHeight there is
     free. It covers dismissal, hiding and wrapping on resize; the childList
     observer covers the bar being removed from the DOM. */
  var announcementBar = document.getElementById('Announcement-header');
  if (announcementBar) {
    if (window.ResizeObserver) {
      new ResizeObserver(setAnnouncementHeight).observe(announcementBar);
    } else {
      window.addEventListener('resize', setAnnouncementHeight);
    }
    if (announcementBar.parentNode) {
      new MutationObserver(setAnnouncementHeight).observe(announcementBar.parentNode, {
        childList: true
      });
    }
  }

  /* ── Drawer open ──────────────────────────────────────────────────────────
   * Styles that depend on the drawer being open key off
   * `body:has(.mobile-menu-drawer[open])` in mn-navigation.css, not a class
   * on <body>. A <body> class change restyles the whole page when certain app
   * CSS is loaded (Alia, on collections), and this ran on every open/close.
   * ─────────────────────────────────────────────────────────────────────── */
  var drawer = document.querySelector('.mobile-menu-drawer');
  if (drawer) {
    function ensureTabpanelVisible() {
      var drawerTabs = document.querySelector('#menu-drawer automatic-tabs');
      if (!drawerTabs) return;
      var panels = drawerTabs.querySelectorAll('.tabpanel');
      if (!panels.length) return;
      var anyVisible = Array.from(panels).some(function(p) { return !p.hasAttribute('hidden'); });
      if (!anyVisible) {
        // All panels are hidden — show panel 0 and hide the rest directly,
        // bypassing AutomaticTabs in case aria-controls was never set.
        panels.forEach(function(p, i) {
          if (i === 0) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', 'hidden');
          }
        });
        var firstTab = drawerTabs.querySelector('.tablist button');
        if (firstTab) {
          firstTab.setAttribute('aria-selected', 'true');
          firstTab.setAttribute('tabindex', '0');
        }
      }
    }

    var drawerObserver = new MutationObserver(function () {
      if (!drawer.hasAttribute('open')) return;
      ensureTabpanelVisible();
      setTimeout(ensureTabpanelVisible, 50);
      setTimeout(ensureTabpanelVisible, 200);
      setTimeout(ensureTabpanelVisible, 600);
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Open Athos search overlay on any search trigger ── */
  function openSearchOverlay() {
    document.dispatchEvent(new CustomEvent('mn:search:open'));
  }

  /* Intercept mousedown on nav search areas — prevents the native input
     from receiving focus before the click event fires. */
  document.addEventListener('mousedown', function (e) {
    if (
      e.target.closest('.mn-search-wrap') ||
      e.target.closest('.mn-drawer-search') ||
      e.target.closest('.mn-mobile-search-bar') ||
      e.target.closest('#mn-mobile-search')
    ) {
      e.preventDefault();
    }
  }, false);

  document.addEventListener('click', function (e) {
    var inStacked       = e.target.closest('.mn-mobile-search-bar .mn-search');
    var inDesktop       = e.target.closest('.mn-search-wrap .mn-search');
    var inDrawer        = e.target.closest('.mn-drawer-search .mn-search');
    var inMobileSearch  = e.target.closest('#mn-mobile-search .mn-search');
    var inHamburgerIcon = e.target.closest('.mn-hamburger-search');
    var inMobileBtn     = e.target.closest('.mn-search-mobile');
    if (inStacked || inDesktop || inDrawer || inMobileSearch || inHamburgerIcon || inMobileBtn) {
      e.preventDefault();
      openSearchOverlay();
    }
  }, false);

  /* ── Rotating search placeholder ──────────────────────────────────────── */
  var config = window.MNNav || {};
  var placeholders = config.placeholders || [];
  if (placeholders.length >= 2) {
    var inputs = document.querySelectorAll('.mn-search__rotating');
    if (inputs.length) {
      var idx = 0;
      setInterval(function () {
        idx = (idx + 1) % placeholders.length;
        inputs.forEach(function (el) {
          if (el !== document.activeElement) {
            el.setAttribute('placeholder', placeholders[idx]);
          }
        });
      }, 3000);
    }
  }
})();

/* ── Country selector: close on outside click ── */
document.addEventListener('click', function(e) {
  var selector = document.getElementById('mn-country-selector');
  if (selector && !selector.contains(e.target)) {
    selector.removeAttribute('open');
  }
});

/* ── Transparent header: solidify past a per-page scroll threshold ── */
(function () {
  var w = document.querySelector('.header-wrapper.mn-headerw--transparent');
  if (!w) return;
  var at = parseInt(w.dataset.solidAt || '200', 10);
  var queued = false;
  function mnSolid() {
    w.classList.toggle('mn-headerw--solid', (window.pageYOffset || document.documentElement.scrollTop || 0) > at);
    queued = false;
  }
  mnSolid();
  window.addEventListener('scroll', function () {
    if (!queued) { queued = true; requestAnimationFrame(mnSolid); }
  }, { passive: true });
})();
